import React, { useContext } from "react";

import { PLAYER_NAMES, SHORT_PLAYER_NAMES } from "../../constants";
import {
  OmahaContext,
  OmahaActionTypes,
  OMAHA_HOLE_CARDS,
  MIN_PLAYERS,
  isComplete
} from "../../context/omahaStore";
import { SUIT_GLYPHS, isRedSuit } from "./DeckPicker";

export function handText(hand) {
  return hand.map(c => c[0] + SUIT_GLYPHS[c[1]]).join(" ");
}

export function HandSlots(props) {
  const { hand, onRemove } = props;
  const slots = [];
  for (let i = 0; i < OMAHA_HOLE_CARDS; i++) {
    const card = hand[i];
    if (!card) {
      slots.push(
        <div className="handSlot handSlot--empty" key={"empty" + i}>
          +
        </div>
      );
      continue;
    }
    const rank = card[0];
    const suit = card[1];
    slots.push(
      <button
        type="button"
        className="handSlot"
        key={card}
        title={card + " — click to remove"}
        onClick={() => onRemove(card)}
      >
        <span className={isRedSuit(suit) ? "handSlotRank suitRed" : "handSlotRank"}>
          {rank}
        </span>
        <span className={isRedSuit(suit) ? "handSlotSuit suitRed" : "handSlotSuit"}>
          {SUIT_GLYPHS[suit]}
        </span>
      </button>
    );
  }
  return <div className="handSlots">{slots}</div>;
}

// One card per seat. A button can't show a four-card hand, so the card carries
// the mode badge and the hand itself.
export default function PlayerStrip(props) {
  const [state, dispatch] = useContext(OmahaContext);
  const atMax = state.players.length >= PLAYER_NAMES.length;

  return (
    <div className="playerStrip">
      {state.players.map(player => {
        const hand = state.hands[player];
        const active = player === state.selected;
        const complete = isComplete(hand);
        return (
          <button
            type="button"
            key={player}
            className={active ? "playerCard playerCard--active" : "playerCard"}
            aria-pressed={active}
            onClick={() =>
              dispatch({ type: OmahaActionTypes.SELECT_PLAYER, player })
            }
          >
            <div className="playerCardHead">
              <span>{SHORT_PLAYER_NAMES[player]}</span>
              <span
                className={
                  "playerBadge " +
                  (complete ? "playerBadge--hand" : "playerBadge--empty")
                }
              >
                {complete ? "hand" : "empty"}
              </span>
            </div>
            <div className="playerCardSummary">
              {hand.length
                ? handText(hand) +
                  (complete ? "" : "  ·  " + hand.length + " of 4")
                : "pick 4 cards"}
            </div>
            {state.players.length > MIN_PLAYERS ? (
              <span
                className="removePlayer"
                role="button"
                title={"Remove " + player}
                onClick={e => {
                  e.stopPropagation();
                  dispatch({ type: OmahaActionTypes.REMOVE_PLAYER, player });
                }}
              >
                remove
              </span>
            ) : null}
          </button>
        );
      })}
      <button
        type="button"
        className="addPlayer"
        disabled={atMax}
        title={atMax ? "Nine players maximum" : "Add a player"}
        onClick={() => dispatch({ type: OmahaActionTypes.ADD_PLAYER })}
      >
        + Add player
      </button>
    </div>
  );
}
